import Link from "ds/components/Link";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";
import { VcsProvider } from "types/generated";

type UserLinkProps = {
  login?: string | null;
  name: string;
  provider: VcsProvider;
  className?: string;
};

const UserLink = ({ login, name, provider }: UserLinkProps) => {
  return (
    <TextEllipsis tooltip={name} tooltipWidthMode="maxWidthSm">
      {(props) =>
        login && provider === VcsProvider.Github ? (
          <Link href={`https://github.com/${login}`} target="_blank" className={props.className}>
            <Typography {...props} tag="span" variant="p-body3">
              {login}
            </Typography>
          </Link>
        ) : (
          <Typography {...props} tag="span" variant="p-body3">
            {name}
          </Typography>
        )
      }
    </TextEllipsis>
  );
};

export default UserLink;
